import { Box, Card, CardContent, Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { FormWithRedirect, TextInput, Toolbar } from "react-admin";
import { CustomDatetime } from "../../../Components/CustomDatetime";
import CreatedByInput from "../../../Components/ReferenceFields/CreatedBy/CreatedByInput";

const ArrivalInfoEditForm = props => {
  return (
    <FormWithRedirect
      {...props}
      render={(formProps: any) => (
        <Card>
          <form>
            <CardContent>
              <Box display={{ md: "block", lg: "flex" }}>
                <Box flex={2}>
                  <Grid container direction="row" justify="space-between" alignItems="flex-start">
                    <Typography variant="h6" gutterBottom color="primary">
                      Creation Information
                    </Typography>
                  </Grid>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CreatedByInput disabled fullWidth />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="createdDate" label="CREATED DATE" fullWidth showTime disabled />
                    </Box>
                  </Box>
                  <Box mt="1em">
                    <Typography variant="h6" gutterBottom color="primary">
                      Updatable Field
                    </Typography>
                  </Box>
                  <Box display={{ xs: "block", sm: "flex" }}>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <CustomDatetime source="arrivalDate" label="Arrival Date" fullWidth showTime />
                    </Box>
                    <Box flex={1} mr={{ xs: 0, sm: "0.5em" }}>
                      <TextInput source="manuelEntryReason" label="Manuel Entry Reason" fullWidth />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </CardContent>
            <Toolbar
              {...props}
              placeholder=""
              record={formProps.record}
              basePath={formProps.basePath}
              undoable={false}
              invalid={formProps.invalid}
              handleSubmitWithRedirect={formProps.handleSubmitWithRedirect}
              redirect={`/requestorders/${props.record.requestId}`}
              // redirect={`/requestorders/${props.record.requestId}/5`}
              saving={formProps.saving}
            />
          </form>
        </Card>
      )}
    />
  );
};

export default ArrivalInfoEditForm;
